import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  templateUrl: './delete-organisation.modal.html'
})
export class DeleteOrganisationModal implements OnInit {

  organisationGuid!: string;
  /** Name of the Organisation to Delete - Used to display what the organisation is about to delete */
  public organisationName!: string;
  private translations = <any>{};
  private customerCount: number = 0;

  constructor(private activeModal: NgbActiveModal, private identityOrganisationApiClient: IdentityOrganisationApiClient, private toastService: ToastService, private translateService: TranslateService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
   }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  private getTranslations() {
    this.translateService.get([
      'Toasts.RemoveOrganisationError',
      'Toasts.RemoveOrganisationSuccess',
      'Toasts.RemoveOrganisationHeader',
      'Toasts.Deleted',
    ]).subscribe(translation => {
      this.translations.toastsRemoveOrganisationError = translation['Toasts.RemoveOrganisationError'];
      this.translations.toastsRemoveOrganisationSuccess = translation['Toasts.RemoveOrganisationSuccess'];
      this.translations.toastRemoveOrganisationHeader = translation['Toasts.RemoveOrganisationHeader'];
      this.translations.toastDeletedHeader = translation['Toasts.Deleted'];
    });
  }

  close() {
    this.activeModal.close(false);
  }

  async delete() {
    if(this.customerCount > 0){
      return this.toastService.showError(this.translations.toastRemoveOrganisationHeader, this.translations.toastsRemoveOrganisationError);
    }
    (await this.identityOrganisationApiClient.deleteOrganisation(this.organisationGuid)).subscribe({
      error: () => {
        this.toastService.showError(this.translations.toastRemoveOrganisationHeader, this.translations.toastsRemoveOrganisationError);
        this.activeModal.close(false);
      },
      next: () => {
        this.toastService.showSuccess(this.translations.toastDeletedHeader, this.translations.toastsRemoveOrganisationSuccess);
        this.activeModal.close(true);
      }
    });
  }

}
